/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InstallCommand } from '../models';
// @ts-ignore
import type { ListAgentsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * AgentsAPIApi - axios parameter creator
 * @export
 */
export const AgentsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the install command for APA runbook-operator.
         * @summary Get the install command for APA runbook operator.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsAPIGetInstallCommand: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('agentsAPIGetInstallCommand', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('agentsAPIGetInstallCommand', 'clusterId', clusterId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/clusters/{clusterId}/apa-agents:getInstallCommand`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the install script for APA runbook-operator.
         * @summary Get the install script for APA runbook operator.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsAPIGetInstallScript: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('agentsAPIGetInstallScript', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('agentsAPIGetInstallScript', 'clusterId', clusterId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/clusters/{clusterId}/apa-agents:getInstallScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the statuses of the APA agents.
         * @summary Get the status of APA agent.
         * @param {string} organizationId The ID of the organization.
         * @param {string} [clusterId] The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsAPIListAgents: async (organizationId: string, clusterId?: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('agentsAPIListAgents', 'organizationId', organizationId)
            const localVarPath = `/application-automation/v1alpha/organizations/{organizationId}/apa-agents`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentsAPIApi - functional programming interface
 * @export
 */
export const AgentsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the install command for APA runbook-operator.
         * @summary Get the install command for APA runbook operator.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentsAPIGetInstallCommand(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstallCommand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agentsAPIGetInstallCommand(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsAPIApi.agentsAPIGetInstallCommand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the install script for APA runbook-operator.
         * @summary Get the install script for APA runbook operator.
         * @param {string} organizationId The ID of the organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentsAPIGetInstallScript(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agentsAPIGetInstallScript(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsAPIApi.agentsAPIGetInstallScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the statuses of the APA agents.
         * @summary Get the status of APA agent.
         * @param {string} organizationId The ID of the organization.
         * @param {string} [clusterId] The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentsAPIListAgents(organizationId: string, clusterId?: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAgentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agentsAPIListAgents(organizationId, clusterId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgentsAPIApi.agentsAPIListAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgentsAPIApi - factory interface
 * @export
 */
export const AgentsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentsAPIApiFp(configuration)
    return {
        /**
         * Get the install command for APA runbook-operator.
         * @summary Get the install command for APA runbook operator.
         * @param {AgentsAPIApiAgentsAPIGetInstallCommandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsAPIGetInstallCommand(requestParameters: AgentsAPIApiAgentsAPIGetInstallCommandRequest, options?: RawAxiosRequestConfig): AxiosPromise<InstallCommand> {
            return localVarFp.agentsAPIGetInstallCommand(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the install script for APA runbook-operator.
         * @summary Get the install script for APA runbook operator.
         * @param {AgentsAPIApiAgentsAPIGetInstallScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsAPIGetInstallScript(requestParameters: AgentsAPIApiAgentsAPIGetInstallScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.agentsAPIGetInstallScript(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * List the statuses of the APA agents.
         * @summary Get the status of APA agent.
         * @param {AgentsAPIApiAgentsAPIListAgentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentsAPIListAgents(requestParameters: AgentsAPIApiAgentsAPIListAgentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListAgentsResponse> {
            return localVarFp.agentsAPIListAgents(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for agentsAPIGetInstallCommand operation in AgentsAPIApi.
 * @export
 * @interface AgentsAPIApiAgentsAPIGetInstallCommandRequest
 */
export interface AgentsAPIApiAgentsAPIGetInstallCommandRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof AgentsAPIApiAgentsAPIGetInstallCommand
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof AgentsAPIApiAgentsAPIGetInstallCommand
     */
    readonly clusterId: string
}

/**
 * Request parameters for agentsAPIGetInstallScript operation in AgentsAPIApi.
 * @export
 * @interface AgentsAPIApiAgentsAPIGetInstallScriptRequest
 */
export interface AgentsAPIApiAgentsAPIGetInstallScriptRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof AgentsAPIApiAgentsAPIGetInstallScript
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof AgentsAPIApiAgentsAPIGetInstallScript
     */
    readonly clusterId: string
}

/**
 * Request parameters for agentsAPIListAgents operation in AgentsAPIApi.
 * @export
 * @interface AgentsAPIApiAgentsAPIListAgentsRequest
 */
export interface AgentsAPIApiAgentsAPIListAgentsRequest {
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof AgentsAPIApiAgentsAPIListAgents
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof AgentsAPIApiAgentsAPIListAgents
     */
    readonly clusterId?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof AgentsAPIApiAgentsAPIListAgents
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof AgentsAPIApiAgentsAPIListAgents
     */
    readonly pageCursor?: string
}

/**
 * AgentsAPIApi - object-oriented interface
 * @export
 * @class AgentsAPIApi
 * @extends {BaseAPI}
 */
export class AgentsAPIApi extends BaseAPI {
    /**
     * Get the install command for APA runbook-operator.
     * @summary Get the install command for APA runbook operator.
     * @param {AgentsAPIApiAgentsAPIGetInstallCommandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsAPIApi
     */
    public agentsAPIGetInstallCommand(requestParameters: AgentsAPIApiAgentsAPIGetInstallCommandRequest, options?: RawAxiosRequestConfig) {
        return AgentsAPIApiFp(this.configuration).agentsAPIGetInstallCommand(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the install script for APA runbook-operator.
     * @summary Get the install script for APA runbook operator.
     * @param {AgentsAPIApiAgentsAPIGetInstallScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsAPIApi
     */
    public agentsAPIGetInstallScript(requestParameters: AgentsAPIApiAgentsAPIGetInstallScriptRequest, options?: RawAxiosRequestConfig) {
        return AgentsAPIApiFp(this.configuration).agentsAPIGetInstallScript(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the statuses of the APA agents.
     * @summary Get the status of APA agent.
     * @param {AgentsAPIApiAgentsAPIListAgentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentsAPIApi
     */
    public agentsAPIListAgents(requestParameters: AgentsAPIApiAgentsAPIListAgentsRequest, options?: RawAxiosRequestConfig) {
        return AgentsAPIApiFp(this.configuration).agentsAPIListAgents(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }
}

